import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export type NewUserFragment = (
  { __typename: 'Member' }
  & Pick<Types.Member, 'id'>
  & { campaigns: Array<(
    { __typename: 'Campaign' }
    & Pick<Types.Campaign, 'id' | 'dateDismissed' | 'name'>
  )> }
);

export const NewUserFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NewUser' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Member' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'campaigns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dateDismissed' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseNewUserFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<NewUserFragment, Apollo.OperationVariables>,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseNewUserFragmentResult
  extends Omit<Apollo.UseFragmentResult<NewUserFragment>, 'data'> {
  data?: NewUserFragment;
}

export const useNewUserFragment = ({
  from,
  returnPartialData,
  ...options
}: UseNewUserFragmentOptions): UseNewUserFragmentResult => {
  const result = Apollo.useFragment<NewUserFragment>({
    ...options,
    fragment: NewUserFragmentDoc,
    fragmentName: 'NewUser',
    from: {
      __typename: 'Member',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as NewUserFragment };
};
